module.exports = __webpack_public_path__ + "static/media/farligwback.19a83bef.svg";